export enum EShoveType {
    FOLDER = 'folder',
    FILE = 'file',
}
